// Maps backend auth error codes → i18n keys so errors show in the user's language.
const MAP = {
  INVALID_CREDENTIALS: "login.invalidCredentials",
  SOCIAL_LOGIN_ONLY: "auth.socialLoginOnly",
  TOO_MANY_ATTEMPTS: "auth.tooManyAttempts",
  ACCOUNT_BLOCKED: "auth.accountBlocked",
  PASSWORD_TOO_SHORT: "login.passwordTooShort",
  NAME_REQUIRED: "auth.nameRequired",
  EMAIL_EXISTS: "auth.emailExists",
  EMAIL_EXISTS_SOCIAL: "auth.emailExistsSocial",
  RESET_LINK_INVALID: "auth.resetLinkInvalid",
  RESET_LINK_EXPIRED: "auth.resetLinkExpired",
};

export const authErrorKey = (detail) =>
  (typeof detail === "string" && MAP[detail]) || null;
